import supportModule from '../../support.module';
import template from './supportViewCase.component.html';
import style from './supportViewCase.component.css';

export default supportModule.component('supportViewCase', {
    template,
    style,
    controller(supportViewCaseService) {
        this.service = supportViewCaseService;
    }
});



// WEBPACK FOOTER //
// ./modules/support/components/support-view-case/supportViewCase.component.js